import { route, string } from 'react-router-typesafe-routes/dom'
const base = 'et/company/:companyId' as const
const companyOnly = { companyId: string().defined() }

export const HOME_ROUTES = {
  creator: route(`${base}/creator`, { params: companyOnly }),
  dashboard: route(`${base}/dashboard`, { params: companyOnly }),
  userProfile: route(`${base}/myprofile`, { params: companyOnly }),
  userCompanies: route(`${base}/mycompanies`, { params: companyOnly }),
}
